/* eslint-disable camelcase,max-len */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Void } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";

type TUploadIconAssetsFunction = {
  uploadIcons: CommandResult_Void;
};

export type TUploadIconAssetsMutations = {
  assets: TUploadIconAssetsFunction;
};
export const uploadIconAssets = () => gql`
  mutation uploadIconAssets($favicon: Upload, $logo: Upload, $logo192: Upload, $logotipo: Upload, $logotipoMinifiedColor: Upload, $logotipoMinifiedWhite: Upload) {
    assets {
      uploadIcons(favicon: $favicon, logo: $logo, logo192: $logo192, logotipo: $logotipo, logotipoMinifiedColor: $logotipoMinifiedColor, logotipoMinifiedWhite: $logotipoMinifiedWhite) {
        ...COMMAND_RESULT
      }
    }
  }
  ${CommandResult("CommandResult_Void")}
`;
